import {
  DashboardIcon,
  CollaborationsIcon,
  WalletIcon,
  MessageIcon
} from '../common/icon';

export const getNavbarMenu = (t: any) => {
  return [
    {
      label: t('navbar.menu.dashboard', { defaultValue: 'Dashboard' }),
      key: 'dashboard',
      icon: DashboardIcon,
      href: '/'
    },

    {
      label: t('navbar.menu.collaborations', {
        defaultValue: 'Brand deals'
      }),
      key: 'collaborations',
      icon: CollaborationsIcon,
      children: [
        {
          label: t('navbar.menu.opportunities', {
            defaultValue: 'Opportunities'
          }),
          key: 'opportunities',
          href: '/deals/opportunities'
        },
        {
          label: t('navbar.menu.deals_active', { defaultValue: 'Active' }),
          key: 'active',
          href: '/deals/active'
        },
        {
          label: t('navbar.menu.deals_completed', {
            defaultValue: 'Completed'
          }),
          key: 'completed',
          href: '/deals/completed'
        }
      ]
    },
    {
      label: t('navbar.menu.new_wallet', { defaultValue: 'Wallet' }),
      key: 'wallet',
      icon: WalletIcon,
      href: '/campaign/wallet'
    },
    {
      label: t('navbar.menu.messages', { defaultValue: 'Messages' }),
      key: 'message',
      icon: MessageIcon
    }
  ];
};
